import { render, staticRenderFns } from "./HospitalProfile.vue?vue&type=template&id=5dd8d590"
import script from "./HospitalProfile.vue?vue&type=script&lang=js"
export * from "./HospitalProfile.vue?vue&type=script&lang=js"
import style0 from "./HospitalProfile.vue?vue&type=style&index=0&id=5dd8d590&prod&lang=css"
import style1 from "./HospitalProfile.vue?vue&type=style&index=1&id=5dd8d590&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports